var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.207 5.08536L11.414 2.29296C11.3212 2.20008 11.2109 2.12641 11.0896 2.07614C10.9682 2.02587 10.8382 2 10.7069 2C10.5755 2 10.4455 2.02587 10.3241 2.07614C10.2028 2.12641 10.0926 2.20008 9.9997 2.29296L2.29312 9.99954C2.19986 10.0921 2.12592 10.2022 2.0756 10.3235C2.02528 10.4449 1.99959 10.575 2.00001 10.7064V13.4994C2.00001 13.7646 2.10536 14.019 2.29289 14.2065C2.48042 14.394 2.73476 14.4994 2.99997 14.4994H13.4996C13.6322 14.4994 13.7593 14.4467 13.8531 14.3529C13.9469 14.2592 13.9995 14.132 13.9995 13.9994C13.9995 13.8668 13.9469 13.7396 13.8531 13.6458C13.7593 13.5521 13.6322 13.4994 13.4996 13.4994H7.20731L14.207 6.49968C14.2999 6.40682 14.3736 6.29657 14.4239 6.17524C14.4741 6.0539 14.5 5.92385 14.5 5.79252C14.5 5.66118 14.4741 5.53113 14.4239 5.40979C14.3736 5.28846 14.2999 5.17821 14.207 5.08536ZM5.79298 13.4994H2.99997V10.7064L8.49976 5.2066L11.2928 7.99962L5.79298 13.4994ZM11.9996 7.29277L9.20723 4.49975L10.7072 2.99981L13.4996 5.79283L11.9996 7.29277Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.29752fa2035f831b1f9e0c022a833e72.svg";
export { ForwardRef as ReactComponent };